import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { SessionStore } from './session.store';

export const guestGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const sessionStore = inject(SessionStore);

  if (await authService.ensureValidSession()) {
    if (sessionStore.snapshot()?.mustChangePassword) {
      return router.createUrlTree(['/change-password']);
    }
    return router.createUrlTree(['/app']);
  }

  return true;
};
